import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getStaffYearlyAttendanceList: (state) => state.items,
  getStaffYearlyAttendancePagination: (state) => state.pagination,
  getStaffYearlyAttendanceListDate: (state) => state.filter.date,
  getStaffYearlyAttendanceListBusy: (state) => state.isBusy,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
